import {
  Solving,
  StatusPanel,
} from "@/components/organisms/SolutionView/SolveStatus";
import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";

/**
 * The build's status, in the solver's pill: the same wait animation over the
 * pitch, and the same shell for the failure. Replaces the old LoadingModal.
 */
export const BuildStatus = ({
  status,
  onClose,
}: {
  status: "pending" | "rejected";
  /** Dismisses the failure panel; the wait cannot be dismissed. */
  onClose: () => void;
}) => {
  const { t } = useTranslation(["squadBuilder", "common"]);

  if (status === "pending")
    return (
      <StatusPanel>
        <Solving label={t("build.buildingMetaSquads")} />
      </StatusPanel>
    );

  return (
    <StatusPanel>
      <div className="flex max-w-80 flex-col items-center gap-3 text-center">
        <p className="text-sm text-neutral-300">
          {t("common:dialog.loading.rejected")}
        </p>
        <Button variant="primary" size="small" onClick={onClose}>
          {t("common:understood")}
        </Button>
      </div>
    </StatusPanel>
  );
};
